module.exports = __webpack_public_path__ + "static/img/banner.97323df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/company/banner.png
// module id = s+GD
// module chunks = 2